import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { redFlagService } from '../services/redFlagService';

export const getRedFlagById = createAsyncThunk(
  'redFlag/getRedFlagById',
  async (id, { rejectWithValue }) => {
    try {
      const response = await redFlagService.getRedFlagById(id);
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const updateRedFlag = createAsyncThunk(
  'redFlag/updateRedFlag',
  async ({ redFlagId, updates }, { rejectWithValue }) => {
    try {
      const response = await redFlagService.updateRedFlag(redFlagId, updates);
      return response?.data || response;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const redFlagSlice = createSlice({
  name: 'redFlag',
  initialState: {
    redFlag: null,
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getRedFlagById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getRedFlagById.fulfilled, (state, action) => {
        state.loading = false;
        state.redFlag = action.payload;
      })
      .addCase(getRedFlagById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(updateRedFlag.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateRedFlag.fulfilled, (state, action) => {
        state.loading = false;
        state.redFlag = action.payload;
      })
      .addCase(updateRedFlag.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = redFlagSlice.actions;

export default redFlagSlice.reducer;
